import { render, staticRenderFns } from "./TextareaFormItem.vue?vue&type=template&id=5c50d117&"
import script from "./TextareaFormItem.vue?vue&type=script&lang=js&"
export * from "./TextareaFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports